import { createApi } from '@reduxjs/toolkit/query/react';
import {
  CustomerCompactDto,
  CustomerContactInfoDto,
  CustomerDto,
  FindAllCustomerDto,
  ResponseDto,
  ResponsePagingDto
} from 'types';
import { FulltextSearchCustomerDto } from 'types/dto/customer-lookup';
import { mergeArrays } from 'utils';
import axiosBaseQuery from 'utils/base-api';

export const toolsApi = createApi({
  reducerPath: 'toolsApi',
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    postRequestSyncCustomer: builder.mutation<ResponseDto<string>, string>({
      query: (customerCode) => ({
        url: `/tools-crm/request-sync-customer/${customerCode}`,
        method: 'post',
      }),
    })
  })
});

export const {
  usePostRequestSyncCustomerMutation,
} = toolsApi;
